import { Component, inject, input, Input } from '@angular/core';
import { MinimalTeamDto } from '@artemis-software/wr-api';
import { Router } from '@angular/router';
import { Tracked } from '@/utils/signals/tracked';

@Component({
  standalone: false,
  selector: 'wr-team-badge',
  templateUrl: './team-badge.component.html',
  styleUrls: ['./team-badge.component.scss']
})
export class TeamBadgeComponent {
  readonly router = inject(Router);

  readonly team = input<MinimalTeamDto>();

  @Input()
  @Tracked()
  disableLink = false;
}
